// extracted by mini-css-extract-plugin
module.exports = {"trustBanner":"TrustBanner_trustBanner__2fZJ9","wrapper":"TrustBanner_wrapper__LE_t1"};